export enum ScrollOptions {
  PRICING_PLAN = "PricingPlan",
  CATALOG_HEALTH = "ImproveCatalogHealth",
  SUPPLY_CHAIN = "SupplyChain",
  BUSSINESS_GROWTH = "BussinessGrowth",
  SELLER_ACCOUNTS = "AmazonSellerAccounts",
  STREAMLINE_SUPPLY_CHAIN = "StreamlineSupplyChain",
  MANAGE_BUSSINESS_GROWTH = "ManageBusinessGrowth",
  LINK_SELLER_ACCOUNTS = "LinkAllAmazonSellerAccounts",
  DEMO = "Demo",
  DASHBOARD = "dashboard",
  DEMO_VIDEO = "DemoVideo",
}
